module.exports = __webpack_public_path__ + "img/Group 427320727@2x.d14c36a1.png";